import { compose } from 'recompose';
import apiInterceptor from '../../../api/interceptor';
import PRNReport from './PRNReport';
import { prnReportApi } from '../../common/base.api';

const composedPRNReport = compose(apiInterceptor({ ...prnReportApi }))(PRNReport);

export default composedPRNReport;
